import { createAPIService } from './api.service';

export const LOCATION_ENDPOINT = '/location/api/locations';

const service = createAPIService(LOCATION_ENDPOINT);

service.createLocation = async location =>
  (await service.post('', location)).data;

service.getLocationByReferenceId = async referenceId =>
  (await service.get(`/references?referenceId=${referenceId}`)).data;

service.updateLocation = async (id, location) =>
  (await service.patch(`/${id}`, location)).data;

export default service;
